exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plans{width:1024px;margin:auto}@media (max-width: 1180px){.plans{width:100%}}.btn-group-1{position:absolute;bottom:30px;right:15px}.plan{border-right:1px solid #e5e5e5;padding:20px 15px;margin:30px auto;min-height:430px}.plan label{color:#265390;font-size:15px;font-weight:600;margin-top:30px}.plan .planPrice{color:#265390;margin-bottom:15px}.plan .planPrice h6{color:#a09f9f;font-size:22px}.plan .planPrice h5{font-size:40px;font-weight:600}.plan .planPrice h5 span{font-size:30px}.plan .planPrice span{font-size:16px}.plan ul{text-align:left;margin-bottom:15px}.plan ul li{color:#68707b;font-size:15px;margin-bottom:8px;list-style-image:url(\"/assets/images/tick_icon.png\")}@media (max-width: 767px){.plan{min-height:0}}.plan:first-child{border-left:1px solid #e5e5e5}.plan:first-child .planPrice{margin:42px 0px}.plan.currentPlan{box-shadow:0px 0px 40px 15px rgba(0,0,0,0.08);border-radius:15px;border:0}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/plans/plans.component.scss
// module id = 1352
// module chunks = 4